import LocalStorageManager from './localStorageManager'
import {limits} from './limits'
import Customer from './customer'
import plans from '../data/plans.json'
import localStorageKeys from './localStorageKeys'

const ENABLED_LIMIT_KEY = 'enabled'
const ENABLED_LIMIT_VALUE = 1
const TEST_ALERT_COUNT = 3
const BUSINESS_PLAN_KEY = 'business#v1'
const PLAN = 'plan'
class LimitManager {
    #getLimitByKey = key => {
        let overriddenLimits = LocalStorageManager.get(limits.overriddenLimits) || []
        overriddenLimits = overriddenLimits?.find(item => item?.key === key)?.value
        const userLimits = LocalStorageManager.get(limits.limits)?.find(item => item?.key === key)?.value
        return overriddenLimits || userLimits || 0
    }

    #isLimitEnabled = key => {
        if (this.isBusinnesPlan) {
            return true
        }
        return this.#getLimitByKey(key) === ENABLED_LIMIT_VALUE
    }

    isPaidPlan = () => localStorage.getItem(PLAN) !== plans.free_v1.key
    isBusinnesPlan = localStorage.getItem(PLAN) === BUSINESS_PLAN_KEY
    isTrialPeriod = () => Customer.isRoot() && this.isPaidPlan() && LocalStorageManager.get(localStorageKeys.TRIAL)

    getResourceLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.resource_count?.limit_key)
    getServerResourceLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.server_resource_count?.limit_key)
    getSMSChannelLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.sms_count_per_month?.limit_key)
    getPhoneCallChannelLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.phone_call_count_per_month?.limit_key)
    getTeamMemberLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.team_member_count?.limit_key)
    getTLDReminderIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.tld_reminder_enabled?.limit_key)
    getSMSChannelIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.sms_channel_enabled?.limit_key)
    getSlackChannelIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.slack_channel_enabled?.limit_key)
    getOnCallScheduleIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.on_call_enabled?.limit_key)
    getWebhookIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.webhook_enabled?.limit_key)
    getSlackChannelLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.slack_channel_count?.limit_key)
    getWebhookChannelIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.webhook_channel_enabled?.limit_key)
    getWebhookChannelLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.per_user_webhook_channel_count?.limit_key)
    getMSTeamsChannelIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.ms_teams_channel_enabled?.limit_key)
    getMSTeamsChannelLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.ms_teams_channel_count?.limit_key)
    getDiscordChannelIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.discord_channel_enabled?.limit_key)
    getTelegramChannelIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.telegram_channel_enabled?.limit_key)
    getDiscordChannelLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.discord_channel_count?.limit_key)
    getServiceLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.service_count?.limit_key)
    getStateDescIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.state_description_enabled?.limit_key)
    getRegionLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.region_count?.limit_key)
    getTeamMemberInvitationIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.team_member_invitation_enabled?.limit_key)
    getSSLReminderIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.ssl_reminder_enabled?.limit_key)
    getHeartbeatLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.heartbeat_count?.limit_key)
    getTestAlertCount = () => TEST_ALERT_COUNT
    getHeartbeatMonitoringIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.heartbeat_monitoring_enabled?.limit_key)
    getKeywordMonitoringIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.keyword_monitoring_enabled?.limit_key)
    getPingMonitoringIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.ping_monitoring_enabled?.limit_key)
    getAdvancedMonitoringIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.advanced_monitoring_enabled?.limit_key)
    getConditionMonitoringIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.condition_monitoring_enabled?.limit_key)
    getEmailMonitoringIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.email_monitoring_enabled?.limit_key)
    getTeamLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.team_count?.limit_key)
    getIntegrationLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.integration_count?.limit_key)
    getPortMonitoringIsEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.port_monitoring_enabled?.limit_key)
    getStatusPageLogoEnabled = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.statuspage_logo_enabled?.limit_key)
    getStatusPageGaTrackingEnabled  = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.statuspage_ga_tracking_enabled?.limit_key)
    getStatusPageSubscriptionEnabled  = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.statuspage_subscription_enabled?.limit_key)
    getStatusPageSubscriptionsCount  = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.statuspage_subscription_count?.limit_key)
    getStatusPagePrivatePageEnabled  = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.statuspage_private_page_enabled?.limit_key)
    getStatusPageDomainEnabled  = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.statuspage_domain_enabled?.limit_key)
    getStatusPageBrandingRemovedEnabled  = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.statuspage_branding_removed_enabled?.limit_key)
    getStatusPageRobotMetaContentsEnabled  = (usageLimits) => this.#isLimitEnabled(usageLimits?.limit_keys?.statuspage_robot_meta_contents_enabled?.limit_key)
    getStatusPagesLimit = (usageLimits) => this.#getLimitByKey(usageLimits?.limit_keys?.statuspage_count?.limit_key)

    getAllLimits = () => LocalStorageManager.get(limits.limits)

    getLimitDiff = (key, value) => {
        return this.#getLimitByKey(key) - value < 0 ? 0 : this.#getLimitByKey(key) - value
    }

    getLimitUsages = (module, key, orgUsageLimits) => {
        return orgUsageLimits?.[module]?.find(orgUsageLimit => orgUsageLimit?.key === key)
    }
}

export {
    ENABLED_LIMIT_KEY,
    ENABLED_LIMIT_VALUE
}

export default new LimitManager()
